import { connect } from 'react-redux';
//
import DashboardPage from 'pages/dashboard/dashboard-page';
import { setPageTitle } from 'store/general/actions';
import { resetSidebar, setSidebarHeaderVisibility } from 'store/sidebar/actions';

const mapDispatchToProps = {
  setPageTitle,
  resetSidebar,
  setSidebarHeaderVisibility,
};

export default connect(null, mapDispatchToProps)(DashboardPage);
